import React from 'react';
import { HashDialog } from '../../../../shared/components/dialog/HashDialog';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { AddGuestBookingDialog } from './AddGuestBookingDialog';

export const PARKING_ADD_GUEST_BOOKING_HASH_PATTERN = '#add-guest-booking';

export interface IAddGuestBookingDialogHashMatches {
	reference: string;
}

export const AddGuestBookingDialogRoute = () => {
	const { t } = useTranslation();

	return (
		<HashDialog
			hash={PARKING_ADD_GUEST_BOOKING_HASH_PATTERN}
			ariaLabel={t('parking_retrieve_guest_booking_header')}
		>
			<AddGuestBookingDialog />
		</HashDialog>
	);
};
